// Grammar Books Data Index
// Main entry point for all grammar books data
// Organized for Supabase migration and systematic data management

import { grammarUnits1Data } from './grammarUnits1Data.js';
import { grammarUnits2Data } from './grammarUnits2Data.js';
import { grammarUnits4Data } from './grammarUnits4Data.js';
import { grammarUnits5Data } from './grammarUnits5Data.js';
import { grammarUnits6Data } from './grammarUnits6Data.js';
import { grammarUnits7Data } from './grammarUnits7Data.js';
import { grammarUnits8Data } from './grammarUnits8Data.js';
import { grammarUnits9Data } from './grammarUnits9Data.js';
import { grammarUnits10Data } from './grammarUnits10Data.js';
import { grammarUnits11Data } from './grammarUnits11Data.js';
import { grammarUnits12Data } from './grammarUnits12Data.js';
import { grammarUnits13Data } from './grammarUnits13Data.js';
import { grammarBookMetadata } from './grammarBookMetadata.js';
import { grammarBookProgress } from './grammarBookProgress.js';

// Combine all grammar units
const grammarUnits = [
  ...grammarUnits1Data, 
  ...grammarUnits2Data, 
  ...grammarUnits4Data,
  ...grammarUnits5Data,
  ...grammarUnits6Data,
  ...grammarUnits7Data,
  ...grammarUnits8Data,
  ...grammarUnits9Data,
  ...grammarUnits10Data,
  ...grammarUnits11Data,
  ...grammarUnits12Data,
  ...grammarUnits13Data
];

// Export the combined grammar units
export { grammarUnits };

// Export individual data arrays for specific access
export { grammarUnits1Data };
export { grammarUnits2Data };
export { grammarUnits4Data };
export { grammarUnits5Data };
export { grammarUnits6Data };
export { grammarUnits7Data };
export { grammarUnits8Data };
export { grammarUnits9Data };
export { grammarUnits10Data };
export { grammarUnits11Data };
export { grammarUnits12Data };
export { grammarUnits13Data };

// Export metadata and progress
export { grammarBookMetadata };
export { grammarBookProgress };

// Utility functions
export const getUnitById = (unitId) => {
  return grammarUnits.find(unit => unit.id === unitId);
};

export const getUnitsByDifficulty = (difficulty) => {
  return grammarUnits.filter(unit => unit.difficulty === difficulty);
};

export const getCompletedUnits = () => {
  return grammarUnits.filter(unit => unit.status === 'completed');
};

export const getUnitsByStatus = (status) => {
  return grammarUnits.filter(unit => unit.status === status);
};

// Default export
export default grammarUnits;
